// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"2fb5b47d32cbd585","1836":"8e1cb86d12966a77","5735":"beb578cc985d134d"}[chunkId] + ".css";
};